import React from 'react'
import { Message } from '@weblite/ts-action/message'
import { getPinnedMessageDecorator } from '$logic/pin/service'
import { MessagePreviewMessageDescriptorTypography } from '$common/messsage-preview'

export function MessageDescriptor({ message }: { message: Message }) {
  const description = getPinnedMessageDecorator(message) || ''
  return (
    <MessagePreviewMessageDescriptorTypography color="neutral500">
      {description}
    </MessagePreviewMessageDescriptorTypography>
  )
}
